import { FormattedMessage } from "react-intl";

const HelpCenter = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.helpCenter.content.body"
                    defaultMessage="Use your company-branded URL for Jira Service Management’s help center."
                />
            </p>
        </div>
    );
};

export default HelpCenter;
